
const seed = {
	currentEmployee: 9,
	active: 0,
	open: false,
};

export default seed;
